(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections-custom"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Dots y flecha anterior: maja-carousel-dots / maja-carousel-area (maja-product-carousel.js).
  // Aquí solo queda la analítica de la sección.

  // Shopify sustituye el HTML al editar la sección. El ciclo de conexión
  // reinicializa los observadores y desconecta los anteriores.
  class MajaFeaturedCollections extends HTMLElement {
    #abortController;
    #intersectionObserver;
    #mutationObserver;
    #safetyTimeout;

    async connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;
      await Promise.resolve();
      if (signal.aborted || !this.isConnected) return;

      this.#intersectionObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.#intersectionObserver.disconnect();
        const activeItem = this.querySelector('.featured-collections-carousel__item.is-selected');
        if (!activeItem) return;
        const cards = activeItem.querySelectorAll('product-card[data-gtag-item-data]');
        if (cards.length) {
          this.fireViewItemList(cards);
          return;
        }
        this.#mutationObserver = new MutationObserver(() => {
          const loadedCards = activeItem.querySelectorAll('product-card[data-gtag-item-data]');
          if (!loadedCards.length) return;
          this.#mutationObserver.disconnect();
          clearTimeout(this.#safetyTimeout);
          this.fireViewItemList(loadedCards);
        });
        this.#mutationObserver.observe(activeItem, { childList: true, subtree: true });
        this.#safetyTimeout = setTimeout(() => this.#mutationObserver?.disconnect(), 5000);
      }, { threshold: 0.1 });
      this.#intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#intersectionObserver?.disconnect();
      this.#mutationObserver?.disconnect();
      clearTimeout(this.#safetyTimeout);
    }

    fireViewItemList(cards) {
      if (typeof gtag !== 'function') return;
      const items = Array.from(cards).map(card => {
        try {
          return JSON.parse(card.dataset.gtagItemData);
        } catch (error) {
          console.error('[featured-collections] Error parsing gtag-item-data', error, card);
          return null;
        }
      }).filter(Boolean);
      if (!items.length) return;
      const listName = this.dataset.analyticsListName
        || this.querySelector('.featured-collections-navigation button[aria-current="true"]')?.textContent.trim()
        || 'Featured Collection';
      gtag('event', 'view_item_list', { ecommerce: null });
      gtag('event', 'view_item_list', {
        item_list_id: 'featured-collection-' + this.dataset.sectionId,
        item_list_name: listName,
        items
      });
    }
  }

  if (!customElements.get('maja-featured-collections')) {
    customElements.define('maja-featured-collections', MajaFeaturedCollections);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
